export enum DonorActivityType
{
    Unknown = 0,
    RecurringCreated = 1,
    RecurringCanceled = 2,
    RecurringRestarted = 3,
    RecurringScheduleEdited = 4,
    RecurringPaymentOptionEdited = 5,
}
